import { render, staticRenderFns } from "./newQuickSign.vue?vue&type=template&id=978c85c2&scoped=true"
import script from "./newQuickSign.vue?vue&type=script&lang=js"
export * from "./newQuickSign.vue?vue&type=script&lang=js"
import style0 from "./newQuickSign.vue?vue&type=style&index=0&id=978c85c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978c85c2",
  null
  
)

export default component.exports